import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TwoFactorState {
  is2FARequired: boolean;
  is2FAVerified: boolean;
  twoFactorToken: string | null;
  set2FARequired: (required: boolean) => void;
  set2FAVerified: (verified: boolean) => void;
  setTwoFactorToken: (token: string | null) => void;
  clear2FA: () => void;
}

export const useTwoFactorStore = create<TwoFactorState>()(
  persist(
    (set) => ({
      is2FARequired: false,
      is2FAVerified: false,
      twoFactorToken: null,
      set2FARequired: (required: boolean) => set({ is2FARequired: required }),
      set2FAVerified: (verified: boolean) => set({ is2FAVerified: verified }),
      setTwoFactorToken: (token: string | null) => set({ twoFactorToken: token }),
      clear2FA: () => set({ 
        is2FARequired: false, 
        is2FAVerified: false, 
        twoFactorToken: null 
      }),
    }),
    {
      name: 'two-factor-storage',
      partialize: (state) => ({ 
        is2FARequired: state.is2FARequired, 
        is2FAVerified: state.is2FAVerified,
        twoFactorToken: state.twoFactorToken
      }),
    }
  )
);
